// extracted by mini-css-extract-plugin
module.exports = {"container":"AppContent_container__126A0","left_menu":"AppContent_left_menu__1Rkx0","main_box":"AppContent_main_box__2HMe3"};